import { createEvent } from 'effector';

export const changeBinsEv = createEvent();

export const changeTableEv = createEvent()
